module.exports = __webpack_public_path__ + "img/312622474_643454180700869_6538168753489670673_n.2d825f56.jpg";